const { __, __x, __nx, __N } = JIX.Gettext;

export default {
    writerDate: (currentStatus, date) =>
        __x('{currentStatus} medarbejder, {date}', { currentStatus: currentStatus, date: String(date) }),
    editComment: () =>
        __('Ret'),
    reportComment: () =>
        __('Anmeld'),
    replyComment: () =>
        __('Besvar'),

    statusName(status) {
        switch (String(status)) {
            case '1':
                return  __('Nuværende');
            case '0':
                return  __('Tidligere');
        }
    },

    responseCommentHeader: (companyname) =>
        __x('Svar fra {companyname}', { companyname }),
    reportResponseComment: () =>
        __('Anmeld kommentar'),

    positiveComment: () =>
        __('Positiv kommentar'),
    negativeComment: () =>
        __('Negativ kommentar'),
};
